import React from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

export default function Testimonials() {
  return (
    <section
      id="reviews"
      className="relative py-24 md:py-32 bg-[#050505] overflow-hidden"
      data-testid="testimonials-section"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-16">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#00BFFF] mb-4">
              — Homeowners Say
            </div>
            <h2 className="font-display text-4xl md:text-6xl uppercase tracking-tighter text-white leading-[0.95]">
              Reviews from
              <br />
              <span className="text-[#C4FF00]">Customers.</span>
            </h2>
          </div>
          <div className="flex items-center gap-2">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} className="h-5 w-5 fill-[#C4FF00] text-[#C4FF00]" />
            ))}
            <span className="ml-2 text-sm uppercase tracking-widest font-bold text-white">
              4.9 / 5.0
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={t.name}
              className="group relative rounded-2xl border border-zinc-800 bg-[#0A0A0A] p-8 hover:border-[#00BFFF]/50 transition-colors"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="h-10 w-10 text-[#C4FF00]/20 absolute top-6 right-6" />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star
                    key={j}
                    className="h-4 w-4 fill-[#C4FF00] text-[#C4FF00]"
                  />
                ))}
              </div>
              <p className="text-lg text-white leading-relaxed">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-6 flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-gradient-to-br from-[#00BFFF] to-[#C4FF00] grid place-items-center font-display text-black">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-bold text-white">{t.name}</div>
                  <div className="text-xs uppercase tracking-widest text-zinc-500 font-bold">
                    {t.city}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
